<script setup lang = "ts">
import {ref} from "vue";
import noImage from "@/assets/images/no-image.png"

const slide = ref('image-0')
defineProps({
	images: {type: Array<string | File | FormData>, required: true},
	isHorizontal: {type: Boolean, default: false},
	hasNavigation: {type: Boolean, default: true},
});

const getImage = (image: any) => {
	if (image!=='' && !`${image}`.startsWith('http')) {
		return `https://cdn.compralovendelo.com/${image.startsWith('/') ? `${image}`.slice(1) : image}`
	} else {
		if (image=='') {
			return `https://cdn.compralovendelo.com/no-image.png`
		} else {
			return image
		}
	}
}

</script>

<template>
	<q-carousel
			v-model = "slide"
			swipeable
			animated
			control-color = "white"
			:navigation = "!!hasNavigation && !isHorizontal"
			arrows
			padding
			ref = "parent"
			height = "100%"
	>
		<q-carousel-slide
				class = "w-full"
				v-for = "(image,index) in images.filter((item):item is string => typeof item === 'string')"
				:name = "`image-${index}`" v-bind:key = "index"
				:img-src = "getImage(image)"/>
	</q-carousel>
</template>

<style scoped>

</style>